import { useEffect, useRef } from "react";

const Cursor = () => {
  const cursorRef = useRef(null);

  useEffect(() => {
    const move = (e) => {
      const cursor = cursorRef.current;
      if (!cursor) return;

      cursor.style.left = e.clientX + "px";
      cursor.style.top = e.clientY + "px";
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <div
      ref={cursorRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,

        width: "22px",
        height: "22px",

        border: "2px solid #2563eb",
        borderRadius: "50%",
        background: "transparent",

        transform: "translate(-50%, -50%)",

        pointerEvents: "none",

        zIndex: 999999,

        boxSizing: "border-box",
      }}
    />
  );
};

export default Cursor;